import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Card, Col, Placeholder, Row } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { CRYPTO_KEY } from '../../helpers/crypto'

import { addPubParamToUrl, getPubAbbr } from '@revbox/helpers-fe'
import { advIntervalAuctionsBreadcrumbs as breadcrumbs, campaignStatusLabels, helpModalLabels, toasts } from '@revbox/localization'
import { cookiesKeyNames } from '@revbox/common-fe'

import { useCookiesContext } from '../../contexts/CookiesContext'
import { SpecificPPCAuctions } from './components/auctions/specific/SpecificPPCAuctions'
import { getInventoryCampaignByInventoryAndCampaign, getPeriodIntervalAuctions, verifyCustomerToken } from '../../services/micro'
import { fetchCampaignData } from './components/common/helpers'
import PPCManagmentModal from './components/auctions/modals/PPCManagmentModal/PPCManagmentModal'
import TablesNavigation from './components/common/TablesNavigation'
import { BrandingPPCAuctions } from './components/auctions/branding/BrandingPPCAuctions'
import { EmailsPPCAuctions } from './components/auctions/emails/EmailsPPCAuctions'

function AdvertiserInterval({}) {
    const isIframe = window !== window.parent

    const urlParams = new URLSearchParams(window.location.search)
    const campaignId = urlParams.get('campaignId')
    const [tokenVerified, setTokenVerified] = useState(null)
    const [publisherId, setPublisherId] = useState(null)
    const [campaign, setCampaign] = useState(null)
    const [updatePage, setUpdatePage] = useState(0)
    const [showModal, setShowModal] = useState(false)
    const [inventoryCampaign, setInventoryCampaign] = useState(null)
    const [currentTab, setCurrentTab] = useState('interval')
    const [anyEmailsAuctions, setAnyEmailsAuctions] = useState(false)
    const [emailsActiveAuctions, setEmailsActiveAuctions] = useState()
    const [anyActiveEmailsBid, setAnyActiveEmailsBid] = useState(null)
    const [brandingActiveAuctions, setBrandingActiveAuctions] = useState()
    const [anyActiveBrandingBid, setAnyActiveBrandingBid] = useState(null)
    const [anyBrandingAuctions, setAnyBrandingAuctions] = useState(false)

    const [anyPPCAuctions, setAnyPPCAuctions] = useState(false)

    const token = urlParams.get('token')

    const { cookiesData, getPathKey, getSkinMode, getLanguageAbbr } = useCookiesContext()

    const currentSkin = getSkinMode()
    const languageAbbr = getLanguageAbbr()
    const multilangBreadcrumbs = breadcrumbs[languageAbbr]
    const navigate = useNavigate()
    const multilangCampaignStatus = campaignStatusLabels[languageAbbr]

    const pubValue = urlParams.get('pub')
    const advIdByCookies = cookiesData[getPathKey()]?.[cookiesKeyNames.advertiserId]

    let isActivePPCAuctions = anyPPCAuctions?.length !== 0 && anyPPCAuctions !== undefined
    let isActiveBrandingAuctions = brandingActiveAuctions?.length !== 0 && brandingActiveAuctions !== undefined

    const multilangHelpModal = helpModalLabels[languageAbbr]

    if (token) {
        verifyCustomerToken(token).then(response => {
            if (response && response?.success) {
                setTokenVerified(true)
                setPublisherId(Number(response?.customer?.publisher_id))
            } else {
                setTokenVerified(false)
            }
        })
    }

    useEffect(() => {
        const fetchData = async () => {
            const campaignData = await fetchCampaignData(isIframe, tokenVerified, campaignId, token)
            if (!campaignData) {
                toast.error(toasts[languageAbbr].errorFetchingCampaign)
                return navigateTo404()
            }
            setCampaign({ ...campaignData.data, ...campaignData?.table })
        }
        fetchData()
    }, [campaignId, token])

    const navigateTo404 = () => {
        const publisherIdByAbbr = getPubAbbr()
        navigate('pages/error-404?pub=' + publisherIdByAbbr)
    }

    const handleClose = () => {
        setShowModal(false)
    }

    const handleShowModal = async row => {
        if (row?.data?.auctionClose?.toLowerCase() === 'closed') {
            return
        }
        const inventoryCampaignData = await getInventoryCampaignByInventoryAndCampaign(row.data.ID, campaignId)
        if (inventoryCampaignData && inventoryCampaignData?.success) {
            setInventoryCampaign(inventoryCampaignData.data)
            setShowModal(true)
        }
    }
    // const multilangBreadcrumbs = breadcrumbs[languageAbbr]

    return (
        <div className={isIframe ? '' : 'main main-app p-3 p-lg-4'}>
            {isIframe ? (
                <></>
            ) : (
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <div>
                        <ol className="breadcrumb fs-sm mb-1">
                            <li className="breadcrumb-item">
                                <Link href="/adv/home" to={addPubParamToUrl('/adv/home', pubValue, advIdByCookies, CRYPTO_KEY)}>
                                    ADV Home
                                </Link>
                            </li>
                            <li className="breadcrumb-item d-flex align-items-center">
                                {campaign ? (
                                    campaign?.name
                                ) : (
                                    <React.Fragment>
                                        <Placeholder as={Card.Title} animation="glow" style={{ color: 'var(--bs-body-color)' }}>
                                            <Placeholder style={{ height: 10, width: 100 }} />
                                        </Placeholder>
                                    </React.Fragment>
                                )}
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                {multilangBreadcrumbs.breadcrumb}
                            </li>
                        </ol>
                        <h2 className="main-title mb-0">{multilangBreadcrumbs.title}</h2>
                        <p className="section-title mt-4 mb-0">
                            {multilangBreadcrumbs.howTitle}: {multilangBreadcrumbs.howDescription}
                        </p>
                    </div>
                </div>
            )}

            <Row className={`g-3 ${isIframe ? 'htr-iframe-bg' : ''}`}>
                {/* {!budgetLoading && campaign && campaign?.id && ( */}
                <>
                    <Col md="12" className="px-4">
                        <TablesNavigation
                            isHTR={true}
                            isAPV={false}
                            campaign={campaign}
                            anyClusterAuctions={false}
                            currentTab={currentTab}
                            updatePage={updatePage}
                            setCurrentTab={setCurrentTab}
                            numberOfClusterAuctions={0}
                            anyPPCAuctions={anyPPCAuctions}
                            isActivePPCAuctions={isActivePPCAuctions}
                            isActiveBrandingAuctions={isActiveBrandingAuctions}
                            anyActiveEmailsBid={anyActiveEmailsBid}
                            multilangCampaignStatus={multilangCampaignStatus}
                            multilangHelpModal={multilangHelpModal}
                            closeHelpModal={() => {}}
                            interval={true}
                        />
                    </Col>
                    <Col md="12">
                        {currentTab === 'branding' && (
                            <BrandingPPCAuctions
                                display={currentTab}
                                updatePage={updatePage}
                                getData={(searchParams, campaign_id) => getPeriodIntervalAuctions(searchParams, campaign_id, 9)}
                                setBrandingActiveAuctions={setBrandingActiveAuctions}
                                setAnyBrandingAuctions={setAnyBrandingAuctions}
                                campaignId={campaign?.id}
                                setAnyActiveBrandingBid={setAnyActiveBrandingBid}
                                onClick={handleShowModal}
                                skin={currentSkin}
                                isHTR={true}
                            />
                        )}

                        {currentTab === 'emails' && (
                            <EmailsPPCAuctions
                                display={currentTab}
                                updatePage={updatePage}
                                getData={(searchParams, campaign_id) => getPeriodIntervalAuctions(searchParams, campaign_id, 8)}
                                campaignId={campaign?.id}
                                setEmailsActiveAuctions={setEmailsActiveAuctions}
                                setAnyEmailsAuctions={setAnyEmailsAuctions}
                                setAnyActiveEmailsBid={setAnyActiveEmailsBid}
                                onClick={handleShowModal}
                                skin={currentSkin}
                                isHTR={true}
                            />
                        )}

                        {currentTab === 'interval' && (
                            <SpecificPPCAuctions
                                display="specific"
                                updatePage={updatePage}
                                getData={(searchParams, campaign_id) => getPeriodIntervalAuctions(searchParams, campaign_id, 6)}
                                campaignId={campaignId}
                                setAnyPPCAuctions={() => {}}
                                setAnyActiveSpecificBid={() => {}}
                                onClick={handleShowModal}
                                skin={getSkinMode()}
                                isHTR={false}
                                auctionType="interval"
                            />
                        )}
                    </Col>
                </>
                {/* )} */}
                {showModal && (
                    <PPCManagmentModal
                        show={showModal}
                        token={token}
                        isClusterInventoryCampaign={false}
                        handleClose={handleClose}
                        views={inventoryCampaign.inventory.forecasted_views}
                        inventoryId={inventoryCampaign?.inventory_id}
                        campaignId={campaignId}
                        updatePage={updatePage}
                        setUpdatePage={setUpdatePage}
                        clusterLevel={0}
                        allChildrenCount={0}
                        anyActiveChild={false}
                        anyInactiveParent={false}
                        allowed={false}
                        auctionType="interval"
                    />
                )}
            </Row>
        </div>
    )
}

export default AdvertiserInterval
